module.exports = __webpack_public_path__ + "media/cow.3e9c17e6.wav";